module.exports = __webpack_public_path__ + "static/media/27OCHA1.ef3a63e5.jpg";